/** LocalStorage key for the per-browser MFA trusted-device identifier (persistent across logout). */
export const REMMI_MFA_TRUSTED_DEVICE_STORAGE_KEY = 'remmi_mfa_trusted_device_id';
